import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';

export default {
  namespace: 'mine',
  state: {
    userId: '',
    pageNum: '',
    pageLimit: '',
    total: '',
    level: '',
    loading: false,
    dataSource: [],
    AllDataSource: [],
  },
  reducers: {
    setDataSource(state, action) {
      const { AllDataSource, pageNum } = state;
      if (pageNum !== action.payload.pageNum) {
        let DataSource = AllDataSource.concat(action.payload.records);
        return {
          ...state,
          pageNum: action.payload.pageNum,
          AllDataSource: DataSource,
          total: action.payload.total,
          dataSource: DataSource,
          loading: false,
        };
      } else {
        return {
          ...state,
          pageNum: action.payload.pageNum,
          total: action.payload.total,
          loading: false,
        };
      }
    },
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },
    setOriginDataSource(state, action) {
      const { pageNum, AllDataSource, totall, dataSource } = action.payload;
      return {
        ...state,
        pageNum,
        AllDataSource,
        totall,
        dataSource,
      };
    },
  },
  effects: {
    *getDataSource(action, { put }) {
      yield put({
        type: 'setLoading',
        payload: true,
      });
      const { pageLimit, pageNum } = action.payload;
      if (pageNum === 1) {
        yield put({
          type: 'setOriginDataSource',
          payload: { pageNum: '', records: [], AllDataSource: [], dataSource: [], totall: '' },
        });
      }
      const res = yield fetch.get(API.MEETING_GET_MINE, { pageNum, pageLimit });
      yield put({
        type: 'setDataSource',
        payload: res.data,
      });
    },
  },
};
